/* eslint-disable no-magic-numbers */

import { nanoid } from 'nanoid';

const prepareEnvValue = (value, defaultValue, type = 'string') => {
    const clearedValue = String(value || defaultValue).trim();
    switch (type) {
    case 'boolean':
        return ['1', 'true', 'True', 'yes', 'Yes'].includes(clearedValue);
    case 'number':
        return +clearedValue;
    case 'array':
        return clearedValue.split(',').map(item => item.trim());
    default:
        return clearedValue;
    }
};

const DEV_LOCAL_API_PORT = '9591';

export const ALLOWED_LOCALES = [
    'ru',
    'kz',
    'uk',
    'en',
    'de',
    'pl',
    'it',
    'fr',
    'fi',
    'es',
    'cz',
    'tr',
    'pt',
    'lt',
    'lv',
    'debug',
];

export const FALLBACK_LOCALE = prepareEnvValue(
    process.env.SEARCH_BOOSTER_FALLBACK_LOCALE,
    'ru',
    'string',
);

export const FORCE_HTTPS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_FORCE_HTTPS,
    '1',
    'boolean',
);

export const IMAGE_PROXY_URL = 'https://functions.yandexcloud.net/d4eccs0tr3i5ubrs3qdu';

const USE_HTTPS = FORCE_HTTPS || document.location.protocol.includes('https');

export const URL_HASH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_URL_HASH,
    'search',
    'string',
);

export const API_TIMEOUT = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_TIMEOUT,
    5000,
    'number',
);

export const API_URL = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_URL,
).replace('https', USE_HTTPS ? 'https' : 'http').replace(DEV_LOCAL_API_PORT, USE_HTTPS ? DEV_LOCAL_API_PORT : (+DEV_LOCAL_API_PORT - 100));

export const BACKUP_API_URL = prepareEnvValue(
    process.env.SEARCH_BOOSTER_BACKUP_API_URL,
).replace('https', USE_HTTPS ? 'https' : 'http').replace(DEV_LOCAL_API_PORT, USE_HTTPS ? DEV_LOCAL_API_PORT : (+DEV_LOCAL_API_PORT - 100));

export const API_URLS = [API_URL, BACKUP_API_URL];

export const API_METHOD_SEARCH_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_SEARCH_PATH,
    'search',
    'string',
);

export const API_METHOD_IMAGE_CONTOURS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_IMAGE_CONTOURS,
    'image-contours',
    'string',
);

export const API_METHOD_POPULAR = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_POPULAR,
    '',
    'string',
);

export const API_METHOD_HISTORY_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_HISTORY_PATH,
    'history',
    'string',
);

export const API_METHOD_SIMILAR_OFFERS_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_SIMILAR_OFFERS_PATH,
    'similar',
    'string',
);

export const API_METHOD_SIMILAR_POPULAR_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_SIMILAR_OFFERS_PATH,
    'rec',
    'string',
);

export const API_METHOD_COMPLETIONS_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_COMPLETIONS_PATH,
    'completions',
    'string',
);

export const API_METHOD_CATEGORIES_PATH = prepareEnvValue(
    process.env.SEARCH_BOOSTER_API_METHOD_CATEGORIES_PATH,
    'categories',
    'string',
);

export const QUERY_SORT_BY_FIELDS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_QUERY_SORT_BY_FIELDS,
    '',
    'array',
);

export const QUERY_PARAMS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_QUERY_PARAMS,
    '',
    'array',
);

export const DEFAULT_QUERY_LIMIT = prepareEnvValue(
    process.env.SEARCH_BOOSTER_DEFAULT_QUERY_LIMIT,
    24,
    'number',
);

export const DEFAULT_QUERY_LIMIT_NAME_CHARS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_DEFAULT_QUERY_LIMIT_NAME_CHARS,
    70,
    'number',
);

export const DEFAULT_FILTER_POSITION = prepareEnvValue(
    process.env.SEARCH_BOOSTER_DEFAULT_FILTER_POSITION,
    'top',
    'string',
);

export const DEFAULT_CATEGORY_GROUP_SIZE_LIMIT = prepareEnvValue(
    process.env.SEARCH_BOOSTER_DEFAULT_CATEGORY_GROUP_SIZE,
    10,
    'number',
);

export const INSTANCE_ID = nanoid();

export const CDN_INIT_SCRIPT_NAME = prepareEnvValue(
    process.env.SEARCH_BOOSTER_CDN_INIT_SCRIPT_NAME,
    'init.js',
    'string',
);

export const CDN_MAIN_SCRIPT_NAME = prepareEnvValue(
    process.env.SEARCH_BOOSTER_CDN_MAIN_SCRIPT_NAME,
    'searchbooster.js',
    'string',
);

export const VERSION = prepareEnvValue(
    process.env.SEARCH_BOOSTER_VERSION,
    'searchbooster.js',
    'string',
);

export const REQUEST_DELAY_MS = prepareEnvValue(
    process.env.SEARCH_BOOSTER_REQUEST_DELAY_MS,
    100,
    'number',
);

export const COOKIE_PREFIX = prepareEnvValue(
    process.env.SEARCH_BOOSTER_COOKIE_PREFIX,
    'searchbooster',
);

export const COOKIE_USER_ID_MAX_AGE = prepareEnvValue(
    process.env.SEARCH_BOOTSER_COOKIE_USER_ID_MAX_AGE,
    400 * 24 * 60 * 60 * 1000,
);
/*
 * Const isFeatureEnabled = (name, envValue) => {
 *     const localValue = localStorage.getItem(name);
 *     if (localValue !== null) {
 *         return localValue === 'true';
 *     }
 *
 *     return !!prepareEnvValue(
 *         envValue,
 *         false,
 *         'boolean',
 *     );
 * };
 */

export const MINIMAL_FONT_SIZE = prepareEnvValue(
    process.env.SEARCH_BOOSTER_MINIMAL_FONT_SIZE,
    16,
    'number',
);

export const FONT_SCALE_TEXT = prepareEnvValue(
    process.env.SEARCH_BOOSTER_FONT_SCALE_TEXT_SIZE,
    MINIMAL_FONT_SIZE,
    'number',
);

export const ENABLE_RESULTS_NO_CATEGORY_CAROUSEL = prepareEnvValue(
    process.env.SEARCH_BOOSTER_ENABLE_RESULTS_NO_CATEGORY_CAROUSEL,
    true,
    'boolean',
);

export const FEATURE_FLAGS = {
    /*
     * USE_MOCKED_COMPLETIONS: isFeatureEnabled(
     *     'SEARCH_BOOSTER_FEATURE_USE_MOCKED_COMPLETIONS',
     *     process.env.SEARCH_BOOSTER_FEATURE_USE_MOCKED_COMPLETIONS,
     * ),
     */
};

export const RESULTS_FORCE_NO_CAROUSEL_ITEMS_COUNT_DESKTOP = prepareEnvValue(
    process.env.SEARCH_BOOSTER_RESULTS_FORCE_NO_CAROUSEL_ITEMS_COUNT_DESKTOP,
    0,
    'number',
);

export const RESULTS_FORCE_NO_CAROUSEL_ITEMS_COUNT_MOBILE = prepareEnvValue(
    process.env.SEARCH_BOOSTER_RESULTS_FORCE_NO_CAROUSEL_ITEMS_COUNT_MOBILE,
    0,
    'number',
);

export const MOUNT_LOCATORS = {
    shopify: '.icon-search, input[name="q"], input[id^="search"], input[type="search"], input[name^="search"], button[id^="search"], [href^="/search"], [data-predictive-search-open-drawer], [data-search], [aria-label="Search"]',
};

export const DEFAULT_FILTERS_LENGTH = 7;
